import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';
import { useSetAtom } from 'jotai';

import { HelmetProvider } from 'react-helmet-async';
import { MobileBlock } from './components/MobileBlock';
import { AppRouter } from './routes/AppRouter';
import { SentryErrorBoundary } from './config/sentry';
import { DisplayError } from './pages/DisplayError';

import { useUser } from './hooks/api/useUser';
import { playModeAtom } from './atom/Atom';
import { PLAY_MODE, PLAY_MODE_PARAM } from './constants/Consts';
import { setSentryUser, clearSentryUser } from './utils/sentryUser';

const App = () => {
  const { getUserInfo, getActiveCourses, user } = useUser();
  const [searchParams] = useSearchParams();
  const setPlayMode = useSetAtom(playModeAtom);

  useEffect(() => {
    if (searchParams.get(PLAY_MODE_PARAM) === PLAY_MODE.FREE) {
      setPlayMode(PLAY_MODE.FREE);
    }
  }, [searchParams, setPlayMode]);

  useEffect(() => {
    (async () => {
      await getUserInfo();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user) {
      getActiveCourses();
      // Set Sentry user context when user data is loaded
      setSentryUser(user);
    } else {
      // Clear Sentry user context when user is null
      clearSentryUser();
    }
  }, [user, getActiveCourses]);

  return (
    <SentryErrorBoundary fallback={() => <DisplayError />} showDialog={false}>
      <HelmetProvider>
        <MobileBlock />
        <AppRouter />
      </HelmetProvider>
    </SentryErrorBoundary>
  );
};

export default App;
